import * as Sentry from '@sentry/react';

import { UserGlobalRole } from '@/api/auth/mutations';

export type SentryUser = {
  id: string;
  email: string;
  role?: UserGlobalRole;
};

export const setSentryUser = (user: SentryUser | null) => {
  if (user) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
    });
    Sentry.setTag('user.role', user.role);
  } else {
    Sentry.setUser(null);
    Sentry.setTag('user_role', undefined);
  }
};
